// removed by extract-text-webpack-plugin
module.exports = {"sel_box_Li":"_1bDR6uyHxd5ZCjDs0xra0P","box_a_biao":"_1ECS83Bw8aLWwnR-17grQR","hud":"_3JGUlyXYe_lxFzDVb5qMoS","hudt":"GTzDRLn3MTJGrvJKtPBnw","hudt_ta":"_3T1V8PPyLTciZMJyc6QMXm","hudi":"CiduujUTKT94wIEHvXlse","huds":"_3XXnXOc87QTpswyyeikQNi","hudd":"_3IANyxObSGLD8OTibKV3FM","hudd_shu":"_1V0Tjd741sZkZTIm1Hlyo_","hudd_tx":"_3-Qxd81b-TfUQEp05IZmMo","hudd_img":"_3fKz1EKb933oszNU1hoCiL","float":"_1jXAxY5lqK-esj_CUJwlae","mr0":"_3mSny-IFzEm_8zoVzWH25w","w420":"_2etG8Q5QWqgXhHTE3mvO0H"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceInfo/ServiceInfo.scss
 ** module id = 1026
 ** module chunks = 0
 **/